<template>
  
</template>
<script>
export default {
  mounted(){
      this.language = 'ar'
      redirect('/')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ar.vue